import { Typography } from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

export const TableHeader = () => {
  const headerStyles = {
    color: '#808080',
    fontSize: 16,
    fontWeight: 600,
  };

  const tableHeaderStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 48,
    background: COLOR_CONFIG['white-smoke'],
    border: `1px solid ${COLOR_CONFIG['white-smoke']}`,
    borderRadius: 12,
    // borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
  };

  return (
    <div style={tableHeaderStyles}>
      <div style={{ width: 48 }} />
      <Typography style={{ ...headerStyles, flexGrow: 1, width: 0 }}>Assessment</Typography>
      <Typography style={{ ...headerStyles, width: 171 }}>Score</Typography>
      <Typography style={{ ...headerStyles, width: 190 }}>Completed On</Typography>
    </div>
  );
};
